import { render, staticRenderFns } from "./profileMain.vue?vue&type=template&id=2d76997e&scoped=true&"
import script from "./profileMain.vue?vue&type=script&lang=js&"
export * from "./profileMain.vue?vue&type=script&lang=js&"
import style0 from "./profileMain.vue?vue&type=style&index=0&id=2d76997e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76997e",
  null
  
)

export default component.exports